import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { ElementName } from '../../../../../constants';
import { useFlexibleUiContext } from '../../../../../state/flexible-ui-context';
import { BaseAvatarGroupElement, toAvatarGroupProps } from '../common';
var AssignedToGroupElement = function AssignedToGroupElement(props) {
  var context = useFlexibleUiContext();
  var data = context ? toAvatarGroupProps(context.assignedToGroup, true) : null;
  return data ? /*#__PURE__*/React.createElement(BaseAvatarGroupElement, _extends({}, data, props, {
    name: ElementName.AssignedToGroup
  })) : null;
};
export default AssignedToGroupElement;